import Horizontal from './Horizontal';
import Vertical from './Vertical';

export default function ({ direction = 'vertical', ...props }) {
  return (
    direction === 'vertical' ? <Vertical { ...props }/> : <Horizontal {...props } />
  )

}
